import React from 'react';
import s from '../AudienceInsights.module.css';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    ResponsiveContainer,
} from 'recharts';
import Spinner from '../../../../shared/ui/spinner/Spinner';

type Props = {
    data: Array<{ label: string; engagement: number; followers: number; posts: number }>;
};

const WeekTick: React.FC<any> = ({ x, y, payload }) => {
    return (
        <text
            x={x}
            y={y}
            dy={8}
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#7F7F7F"
            style={{
                fontFamily: 'Figtree',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: 12,
                lineHeight: '16px',
                letterSpacing: 0,
                fill: '#7F7F7F',
            }}
        >
            {payload?.value}
        </text>
    );
};

const BrandVoiceChart: React.FC<Props> = ({ data }) => {
    console.log('BrandVoiceChart data:', data);

    if (!data || data.length === 0) {
        return (
            <div className={s.card}>
                <p className={s.cardTitle}>Brand voice consistency</p>
                <div
                    className={s.chartWrap}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '220px',
                    }}
                >
                    No data available
                </div>
            </div>
        );
    }

    const hasData = data.some(
        (item) =>
            (item.engagement && item.engagement > 0) ||
            (item.followers && item.followers > 0) ||
            (item.posts && item.posts > 0),
    );

    if (!hasData) {
        return (
            <div className={s.card}>
                <p className={s.cardTitle}>Brand voice consistency</p>
                <div
                    className={s.chartWrap}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '220px',
                    }}
                >
                    <p style={{ color: '#7F7F7F', fontSize: '14px' }}>
                        No data available for this period
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className={s.card}>
            <p className={s.cardTitle}>Brand voice consistency</p>
            <div className={s.chartWrap}>
                <ResponsiveContainer width="100%" height={220}>
                    <LineChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#ECECEC" />
                        <XAxis
                            dataKey="label"
                            tick={<WeekTick />}
                            tickMargin={8}
                            axisLine={false}
                        />
                        <YAxis
                            tick={{ fontSize: 12 }}
                            axisLine={false}
                            tickLine={false}
                            domain={[0, 100]}
                        />
                        <RechartsTooltip cursor={{ stroke: '#eee' }} />
                        {/* <Line
                            type="monotone"
                            dataKey="engagement"
                            stroke="#FFB000"
                            strokeWidth={3}
                            dot={{ r: 2, fill: '#FFB000', stroke: '#FFB000' }}
                            activeDot={{ r: 4, fill: '#FFB000', stroke: '#FFB000' }}
                        /> */}
                        <Line
                            type="monotone"
                            dataKey="followers"
                            stroke="#FF62B7"
                            strokeWidth={3}
                            dot={{ r: 2, fill: '#FF62B7', stroke: '#FF62B7' }}
                            activeDot={{ r: 4, fill: '#FF62B7', stroke: '#FF62B7' }}
                        />
                        <Line
                            type="monotone"
                            dataKey="posts"
                            stroke="#7A5AF8"
                            strokeWidth={3}
                            dot={{ r: 2, fill: '#7A5AF8', stroke: '#7A5AF8' }}
                            activeDot={{ r: 4, fill: '#7A5AF8', stroke: '#7A5AF8' }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className={s.legendRow}>
                {/* <div className={s.legendItem}>
                    <span className={s.dot} style={{ background: '#FFB000' }} />
                    Engagement trend
                </div> */}
                <div className={s.legendItem}>
                    <span className={s.dot} style={{ background: '#FF62B7' }} />
                    Follower trend
                </div>
                <div className={s.legendItem}>
                    <span className={s.dot} style={{ background: '#7A5AF8' }} />
                    Post frequency
                </div>
            </div>
        </div>
    );
};

export default BrandVoiceChart;
